module.exports = __webpack_public_path__ + "img/casa.405b68d1.svg";